const LINK_PREVIEW_CHARACTER_LIMIT = 50;
const SM_BREAKPOINT_PX = 400;
const MAX_LINKS_TO_RENDER = 3;
const MIN_LINKS_TO_RENDER = 1;

const constants = {
  LINK_PREVIEW_CHARACTER_LIMIT,
  SM_BREAKPOINT_PX,
  MAX_LINKS_TO_RENDER,
  MIN_LINKS_TO_RENDER,
  SUBMIT_TICKET_PATH: "submit",
  SUBMIT_TICKET_TEXT: "Submit a ticket without logging in",
  ATO_INSIGHT_PRODUCT_CATEGORY: "support_suspension_ato",
};

export const SESSION_KEY = {
  INTERRUPTED_CHAT_ID: "interruptedchatid",
};

export const homeInsightWrapperPrompt = (insight: string) => `
  I need help with the following issue on my account: 

  ${insight}
`;

export default constants;
